import { all } from "redux-saga/effects";
import bundleSagas from "../bundles/state/bundles/sagas.js";
import configurationSagas from "../configurations/state/configurations/sagas.js";
const productsSagas = [...bundleSagas, ...configurationSagas];
function* prescriptionGlassesSaga() {
  yield all(productsSagas);
}
export {
  prescriptionGlassesSaga as default,
  productsSagas
};
//# sourceMappingURL=sagas.js.map
